<template>
    <div class="home">
        <navbar :isHiddenlogin="false"></navbar>
    </div>
</template>
<script>
import navbar from '@/components/nav.vue'
export default {
    name: "index",
    components: {
        navbar
    },
    data() {
        return {
           
        }
    },
    computed: {

    },
    methods: {
    },
    mounted() {
      
    }
}
</script>
<style scoped>

</style>